import React from "react";
import "../../stylesheets/species-selector.scss";


export const SpeciesSelector = (
	{
		inputRef,
		namingType,
		optionContainerRef,
		options,
		processing,
		onClick,
		handleOptionsDisplay,
		showFeedback,
	} = {}
) => {
	let placeholder = processing ? "Retrieving species list" : (namingType ? 'Try: "Oak" or "Maple"' : 'Try: "Quercus" or "Acer"');

	const onChange = (event) => {
		event.currentTarget.classList.remove("is-invalid");
		showFeedback(false);
		handleOptionsDisplay();
	};

	const handleClick = (event) => {
		event.currentTarget.select();
		handleOptionsDisplay();
	}

	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			handleClick(event);
		}
	};

	return (
		<React.Fragment>
			<div id={"species-select-container"}>
				<input
					id={"species-input"}
					className={"form-control species-input"}
					placeholder={placeholder}
					ref={inputRef}
					onChange={onChange}
					onClick={handleClick}
					onKeyDown={handleKeyDown}
				/>
				<div
					ref={optionContainerRef}
					className={`option-container ${options.length ? "open" : "close"}`}
					onClick={onClick}
				>
					{options.map((option, index) => {
						return option
					})}
				</div>
			</div>
		</React.Fragment>
	)
};
